import { Map } from 'immutable'
import { Action } from '@ngrx/store'
import * as PropertiesTypes from './properties.types'
import { Property, RDN, CommercialLicense } from './properties.interface'

export class FetchPropertiesRequest implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTIES_REQUEST
  constructor(public propertyType: string, public payload: object) {}
}

export class FetchPropertiesSuccess implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTIES_SUCCESS
  constructor(
    public payload: Property[],
    public total: number,
    public filtered: number,
  ) {}
}

export class FetchPropertiesFailure implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTIES_FAILURE
  constructor(public payload: any) {}
}

export class GeneratePropertyRDNsRequest implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_RDNS_REQUEST
  constructor(public id: any) {}
}

export class GeneratePropertyRDNsSuccess implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_RDNS_SUCCESS
  constructor(public payload: RDN[]) {}
}

export class GeneratePropertyRDNsFailure implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_RDNS_FAILURE
  constructor(public payload: any) {}
}

export class GenerateCommercialLicensesRequest implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_COMMERCIAL_LICENSES_REQUEST
  constructor(public id: any) {}
}

export class GenerateCommercialLicensesSuccess implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_COMMERCIAL_LICENSES_SUCCESS
  constructor(public payload: CommercialLicense[]) {}
}

export class GenerateCommercialLicensesFailure implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_COMMERCIAL_LICENSES_FAILURE
  constructor(public payload: any) {}
}

export class UploadDocumentRequest implements Action {
  readonly type = PropertiesTypes.UPLOAD_DOCUMENT_REQUEST
  constructor(public id: any, public payload: any) {}
}

export class UploadDocumentSuccess implements Action {
  readonly type = PropertiesTypes.UPLOAD_DOCUMENT_SUCCESS
  constructor(public payload: any) {}
}

export class UploadDocumentFailure implements Action {
  readonly type = PropertiesTypes.UPLOAD_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class DeleteDocumentRequest implements Action {
  readonly type = PropertiesTypes.DELETE_DOCUMENT_REQUEST
  constructor(public id: any) {}
}

export class DeleteDocumentSuccess implements Action {
  readonly type = PropertiesTypes.DELETE_DOCUMENT_SUCCESS
  constructor(public payload: any) {}
}

export class DeleteDocumentFailure implements Action {
  readonly type = PropertiesTypes.DELETE_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class DeletePaymentRequest implements Action {
  readonly type = PropertiesTypes.DELETE_PAYMENT_REQUEST
  constructor(public id: any) {}
}

export class DeletePaymentSuccess implements Action {
  readonly type = PropertiesTypes.DELETE_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class DeletePaymentFailure implements Action {
  readonly type = PropertiesTypes.DELETE_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class UploadPropertyImageRequest implements Action {
  readonly type = PropertiesTypes.UPLOAD_PROPERTY_IMAGE_REQUEST
  constructor(public id: number, public payload: any) {}
}

export class UploadPropertyImageSuccess implements Action {
  readonly type = PropertiesTypes.UPLOAD_PROPERTY_IMAGE_SUCCESS
  constructor(public payload: object) {}
}

export class UploadPropertyImageFailure implements Action {
  readonly type = PropertiesTypes.UPLOAD_PROPERTY_IMAGE_FAILURE
  constructor(public payload: any) {}
}

export class DeletePropertyImageRequest implements Action {
  readonly type = PropertiesTypes.DELETE_PROPERTY_IMAGE_REQUEST
  constructor(public id: number, public imageTypeId: number) {}
}

export class DeletePropertyImageSuccess implements Action {
  readonly type = PropertiesTypes.DELETE_PROPERTY_IMAGE_SUCCESS
  constructor(public payload: object) {}
}

export class DeletePropertyImageFailure implements Action {
  readonly type = PropertiesTypes.DELETE_PROPERTY_IMAGE_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyRequest implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_REQUEST
  constructor(public id: number) {}
}

export class FetchPropertySuccess implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_SUCCESS
  constructor(public payload: object) {}
}

export class FetchPropertyFailure implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_FAILURE
  constructor(public payload: any) {}
}

export class CreatePropertyRequest implements Action {
  readonly type = PropertiesTypes.CREATE_PROPERTY_REQUEST
  constructor(public payload: object) {}
}

export class CreatePropertySuccess implements Action {
  readonly type = PropertiesTypes.CREATE_PROPERTY_SUCCESS
  constructor(public payload: object) {}
}

export class CreatePropertyFailure implements Action {
  readonly type = PropertiesTypes.CREATE_PROPERTY_FAILURE
  constructor(public payload: any) {}
}

export class UpdatePropertyRequest implements Action {
  readonly type = PropertiesTypes.UPDATE_PROPERTY_REQUEST
  constructor(
    public id: number,
    public payload: object,
    public nextStatus: string,
  ) {}
}

export class UpdatePropertySuccess implements Action {
  readonly type = PropertiesTypes.UPDATE_PROPERTY_SUCCESS
  constructor(public payload: object) {}
}

export class UpdatePropertyFailure implements Action {
  readonly type = PropertiesTypes.UPDATE_PROPERTY_FAILURE
  constructor(public payload: any) {}
}

export class FetchActiveFormRequest implements Action {
  readonly type = PropertiesTypes.FETCH_ACTIVE_FORM_REQUEST
  constructor() {}
}

export class FetchActiveFormSuccess implements Action {
  readonly type = PropertiesTypes.FETCH_ACTIVE_FORM_SUCCESS
  constructor(public payload: any) {}
}

export class FetchActiveFormFailure implements Action {
  readonly type = PropertiesTypes.FETCH_ACTIVE_FORM_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertySettingsRequest implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_SETTINGS_REQUEST
  constructor() {}
}

export class FetchPropertySettingsSuccess implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchPropertySettingsFailure implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class CreatePropertyPaymentRequest implements Action {
  readonly type = PropertiesTypes.CREATE_PROPERTY_PAYMENT_REQUEST
  constructor(public payload: object) {}
}

export class CreatePropertyPaymentSuccess implements Action {
  readonly type = PropertiesTypes.CREATE_PROPERTY_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class CreatePropertyPaymentFailure implements Action {
  readonly type = PropertiesTypes.CREATE_PROPERTY_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class UpdatePropertyPaymentRequest implements Action {
  readonly type = PropertiesTypes.UPDATE_PROPERTY_PAYMENT_REQUEST
  constructor(public payload: object) {}
}

export class UpdatePropertyPaymentSuccess implements Action {
  readonly type = PropertiesTypes.UPDATE_PROPERTY_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class UpdatePropertyPaymentFailure implements Action {
  readonly type = PropertiesTypes.UPDATE_PROPERTY_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class CalculateFeaturesRequest implements Action {
  readonly type = PropertiesTypes.CALCULATE_FEATURES_REQUEST
  constructor(public payload: any) {}
}

export class CalculateFeaturesSuccess implements Action {
  readonly type = PropertiesTypes.CALCULATE_FEATURES_SUCCESS
  constructor(public parent: string, public payload: any) {}
}

export class CalculateFeaturesFailure implements Action {
  readonly type = PropertiesTypes.CALCULATE_FEATURES_FAILURE
  constructor(public payload: any) {}
}

export class DownloadPropertyDocumentRequest implements Action {
  readonly type = PropertiesTypes.DOWNLOAD_PROPERTY_DOCUMENT_REQUEST
  constructor(
    public payload: {
      propertyId: any
      dataCycleId: any
      propertyType: any
      id?: any
    },
  ) {}
}

export class DownloadPropertyDocumentSuccess implements Action {
  readonly type = PropertiesTypes.DOWNLOAD_PROPERTY_DOCUMENT_SUCCESS
  constructor(public payload: any, public document: Map<string, any>) {}
}

export class DownloadPropertyDocumentFailure implements Action {
  readonly type = PropertiesTypes.DOWNLOAD_PROPERTY_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class GeneratePropertyDocumentRequest implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_DOCUMENT_REQUEST
  constructor(
    public payload: {
      propertyId: any
      propertyType: any
    },
  ) {}
}

export class GeneratePropertyDocumentSuccess implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_DOCUMENT_SUCCESS
  constructor(public payload: any, public document: Map<string, any>) {}
}

export class GeneratePropertyDocumentFailure implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class DownloadPaymentReceiptRequest implements Action {
  readonly type = PropertiesTypes.DOWNLOAD_PAYMENT_RECEIPT_REQUEST
  constructor(public payment: Map<string, any>) {}
}

export class DownloadPaymentReceiptSuccess implements Action {
  readonly type = PropertiesTypes.DOWNLOAD_PAYMENT_RECEIPT_SUCCESS
  constructor(public payload: any, public payment: Map<string, any>) {}
}

export class DownloadPaymentReceiptFailure implements Action {
  readonly type = PropertiesTypes.DOWNLOAD_PAYMENT_RECEIPT_FAILURE
  constructor(public payload: any) {}
}

export class GeneratePaymentReportRequest implements Action {
  readonly type = PropertiesTypes.GENERATE_PAYMENT_REPORT_REQUEST
  constructor(public propertyId: number) {}
}

export class GeneratePaymentReportSuccess implements Action {
  readonly type = PropertiesTypes.GENERATE_PAYMENT_REPORT_SUCCESS
  constructor(public payload: any, public propertyId: number) {}
}

export class GeneratePaymentReportFailure implements Action {
  readonly type = PropertiesTypes.GENERATE_PAYMENT_REPORT_FAILURE
  constructor(public payload: any) {}
}

export class GeneratePaymentTaxpayerReportRequest implements Action {
  readonly type = PropertiesTypes.GENERATE_PAYMENT_TAXPAYER_REPORT_REQUEST
  constructor(public propertyId: number) {}
}

export class GeneratePaymentTaxpayerReportSuccess implements Action {
  readonly type = PropertiesTypes.GENERATE_PAYMENT_TAXPAYER_REPORT_SUCCESS
  constructor(public payload: any, public propertyId: number) {}
}

export class GeneratePaymentTaxpayerReportFailure implements Action {
  readonly type = PropertiesTypes.GENERATE_PAYMENT_TAXPAYER_REPORT_FAILURE
  constructor(public payload: any) {}
}

export class GenerateBusinessLicenceReportRequest implements Action {
  readonly type = PropertiesTypes.GENERATE_BUSINESS_LICENCE_REPORT_REQUEST
  constructor(public propertyId: number) {}
}

export class GenerateBusinessLicenceReportSuccess implements Action {
  readonly type = PropertiesTypes.GENERATE_BUSINESS_LICENCE_REPORT_SUCCESS
  constructor(public payload: any, public propertyId: number) {}
}

export class GenerateBusinessLicenceReportFailure implements Action {
  readonly type = PropertiesTypes.GENERATE_BUSINESS_LICENCE_REPORT_FAILURE
  constructor(public payload: any) {}
}

export class GeneratePropertyReportRequest implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_REPORT_REQUEST
  constructor(public propertyId: number, public propertyType: string) {}
}

export class GeneratePropertyReportSuccess implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_REPORT_SUCCESS
  constructor(
    public payload: any,
    public propertyId: number,
    public propertyType: string,
  ) {}
}

export class GeneratePropertyReportFailure implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_REPORT_FAILURE
  constructor(public payload: any) {}
}

export class GeneratePropertyBusinessReportRequest implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_BUSINESS_REPORT_REQUEST
  constructor(public businessId: number) {}
}

export class GeneratePropertyBusinessReportSuccess implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_BUSINESS_REPORT_SUCCESS
  constructor(public payload: any, public businessId: number) {}
}

export class GeneratePropertyBusinessReportFailure implements Action {
  readonly type = PropertiesTypes.GENERATE_PROPERTY_BUSINESS_REPORT_FAILURE
  constructor(public payload: any) {}
}

export class SetPropertyFieldVisitRequest implements Action {
  readonly type = PropertiesTypes.SET_PROPERTY_FIELD_VISIT_REQUEST
  constructor(public appealId: number, public payload: object) {}
}

export class SetPropertyFieldVisitSuccess implements Action {
  readonly type = PropertiesTypes.SET_PROPERTY_FIELD_VISIT_SUCCESS
  constructor(public payload: any) {}
}

export class SetPropertyFieldVisitFailure implements Action {
  readonly type = PropertiesTypes.SET_PROPERTY_FIELD_VISIT_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = PropertiesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = PropertiesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export class FetchPropertyDocumentsRequest implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_DOCUMENTS_REQUEST
  constructor(public id: number) {}
}

export class FetchPropertyDocumentsSuccess implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_DOCUMENTS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchPropertyDocumentsFailure implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_DOCUMENTS_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyPaymentsRequest implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_PAYMENTS_REQUEST
  constructor(public id: number) {}
}

export class FetchPropertyPaymentsSuccess implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_PAYMENTS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchPropertyPaymentsFailure implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_PAYMENTS_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyDynamicFieldsRequest implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_DYNAMIC_FIELDS_REQUEST
  constructor() {}
}

export class FetchPropertyDynamicFieldsSuccess implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_DYNAMIC_FIELDS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchPropertyDynamicFieldsFailure implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_DYNAMIC_FIELDS_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyHistoryRequest implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_HISTORY_REQUEST
  constructor(public id: number, public payload: any) {}
}

export class FetchPropertyHistorySuccess implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_HISTORY_SUCCESS
  constructor(
    public payload: any[],
    public total: number,
    public filtered: number,
  ) {}
}

export class ArchivePropertyRequest implements Action {
  readonly type = PropertiesTypes.ARCHIVE_PROPERTY_REQUEST
  constructor(public id: number) {}
}

export class ArchivePropertySuccess implements Action {
  readonly type = PropertiesTypes.ARCHIVE_PROPERTY_SUCCESS
  constructor(public payload: object) {}
}

export class ArchivePropertyFailure implements Action {
  readonly type = PropertiesTypes.ARCHIVE_PROPERTY_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyHistoryFailure implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_HISTORY_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyBusinessesRequest implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_BUSINESSES_REQUEST
  constructor(public id: number) {}
}

export class FetchPropertyBusinessesSuccess implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_BUSINESSES_SUCCESS
  constructor(public payload: any) {}
}

export class FetchPropertyBusinessesFailure implements Action {
  readonly type = PropertiesTypes.FETCH_PROPERTY_BUSINESSES_FAILURE
  constructor(public payload: any) {}
}

export type Actions =
  | FetchPropertiesSuccess
  | FetchPropertiesFailure
  | FetchPropertiesRequest
  | FetchPropertyRequest
  | FetchPropertySuccess
  | FetchPropertyFailure
  | SetDefaultData
  | UpdateField
  | FetchActiveFormRequest
  | FetchActiveFormSuccess
  | FetchActiveFormFailure
  | UpdatePropertyRequest
  | UpdatePropertySuccess
  | UpdatePropertyFailure
  | FetchPropertySettingsRequest
  | FetchPropertySettingsSuccess
  | FetchPropertySettingsFailure
  | CreatePropertyRequest
  | CreatePropertySuccess
  | CreatePropertyFailure
  | UploadPropertyImageRequest
  | UploadPropertyImageSuccess
  | UploadPropertyImageFailure
  | DeletePropertyImageRequest
  | DeletePropertyImageSuccess
  | DeletePropertyImageFailure
  | GeneratePropertyRDNsRequest
  | GeneratePropertyRDNsSuccess
  | GeneratePropertyRDNsFailure
  | UploadDocumentRequest
  | UploadDocumentSuccess
  | UploadDocumentFailure
  | DeleteDocumentRequest
  | DeleteDocumentSuccess
  | DeleteDocumentFailure
  | DeletePaymentRequest
  | DeletePaymentSuccess
  | DeletePaymentFailure
  | CreatePropertyPaymentRequest
  | CreatePropertyPaymentSuccess
  | CreatePropertyPaymentFailure
  | UpdatePropertyPaymentRequest
  | UpdatePropertyPaymentSuccess
  | UpdatePropertyPaymentFailure
  | GenerateCommercialLicensesRequest
  | GenerateCommercialLicensesSuccess
  | GenerateCommercialLicensesFailure
  | CalculateFeaturesRequest
  | CalculateFeaturesSuccess
  | CalculateFeaturesFailure
  | DownloadPropertyDocumentRequest
  | DownloadPropertyDocumentSuccess
  | DownloadPropertyDocumentFailure
  | DownloadPaymentReceiptRequest
  | DownloadPaymentReceiptSuccess
  | DownloadPaymentReceiptFailure
  | GeneratePaymentReportRequest
  | GeneratePaymentReportSuccess
  | GeneratePaymentReportFailure
  | GeneratePropertyReportRequest
  | GeneratePropertyReportSuccess
  | GeneratePropertyReportFailure
  | GeneratePropertyBusinessReportRequest
  | GeneratePropertyBusinessReportSuccess
  | GeneratePropertyBusinessReportFailure
  | GeneratePaymentTaxpayerReportRequest
  | GeneratePaymentTaxpayerReportSuccess
  | GeneratePaymentTaxpayerReportFailure
  | SetPropertyFieldVisitRequest
  | SetPropertyFieldVisitSuccess
  | SetPropertyFieldVisitFailure
  | GenerateBusinessLicenceReportRequest
  | GenerateBusinessLicenceReportSuccess
  | GenerateBusinessLicenceReportFailure
  | FetchPropertyDocumentsRequest
  | FetchPropertyDocumentsSuccess
  | FetchPropertyDocumentsFailure
  | FetchPropertyPaymentsRequest
  | FetchPropertyPaymentsSuccess
  | FetchPropertyPaymentsFailure
  | GeneratePropertyDocumentRequest
  | GeneratePropertyDocumentSuccess
  | GeneratePropertyDocumentFailure
  | FetchPropertyDynamicFieldsRequest
  | FetchPropertyDynamicFieldsSuccess
  | FetchPropertyDynamicFieldsFailure
  | FetchPropertyHistoryRequest
  | FetchPropertyHistorySuccess
  | FetchPropertyHistoryFailure
  | ArchivePropertyRequest
  | ArchivePropertySuccess
  | ArchivePropertyFailure
  | FetchPropertyBusinessesRequest
  | FetchPropertyBusinessesSuccess
  | FetchPropertyBusinessesFailure
